const values = [
  {
    icon: "ri-speed-line",
    title: "稳定优先",
    desc: "把看番的流畅度放在第一位，多源播放与自动选源始终以稳定为衡量标准。",
  },
  {
    icon: "ri-heart-line",
    title: "体验至上",
    desc: "每一个切换动作都力求秒级完成，把打扰降到最低，让追番回归纯粹的快乐。",
  },
  {
    icon: "ri-shield-check-line",
    title: "持续守护",
    desc: "各线路源持续巡检，及时发现并标记不可用的来源，备用线路随时待命。",
  },
];

export default function About() {
  return (
    <section id="about" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
          <div>
            <span className="inline-block rounded-full bg-accent-100 px-4 py-1 text-sm font-medium text-accent-900">
              关于我们
            </span>
            <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">
              小猴看番，让每一集都不被卡顿辜负
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              我们是一群热爱动画的追番人。看番最扫兴的莫过于剧情高潮时画面突然卡住、
              转圈等待。小猴看番因此而生——聚合多个线路播放源，把线路切换、
              备用线路秒切和多源播放自动选源做进每一次观看里。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              我们的目标很简单：让每位观众都能快速找到流畅线路，专心享受故事本身。
              无论是新番热播还是经典补番，小猴看番都希望成为你稳定的看番伙伴。
            </p>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {values.map((v) => (
                <div
                  key={v.title}
                  className="rounded-lg border border-background-200 bg-background-100 p-4"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                    <i className={`${v.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-3 text-sm font-semibold text-foreground-950">{v.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-700">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500 text-background-50">
                  <i className="ri-double-quotes-l text-xl"></i>
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">"追番十年，第一次不用再到处找备用线路。"</p>
                  <p className="mt-1 text-xs text-foreground-700">—— 追番重度用户 · 阿航</p>
                </div>
              </div>
              <div className="mt-4 flex items-center gap-1 text-secondary-500">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <span className="ml-2 text-xs text-foreground-700">5.0 / 5</span>
              </div>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50">
                  <i className="ri-user-heart-line text-xl"></i>
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">"多源播放自动选源，晚高峰看番也没卡过。"</p>
                  <p className="mt-1 text-xs text-foreground-700">—— 上班族观众 · 小鹿</p>
                </div>
              </div>
              <div className="mt-4 flex items-center gap-1 text-secondary-500">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-half-line"></i>
                <span className="ml-2 text-xs text-foreground-700">4.8 / 5</span>
              </div>
            </div>

            <div className="rounded-lg bg-background-200/70 p-5 md:p-6">
              <p className="text-sm leading-relaxed text-foreground-800">
                遇到线路问题或有任何建议，欢迎来信告诉我们。你的每一次反馈，
                都在帮助小猴看番把线路切换做得更顺滑。
              </p>
              <a
                href="mailto:support@xiaohoukanfan.example.com"
                className="mt-3 inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700"
              >
                <i className="ri-mail-send-line"></i>
                support@xiaohoukanfan.example.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}